module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("LOGO")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(!_vm.newImageBase64) ? _c('img', {
    staticClass: "avatar pointer",
    attrs: {
      "src": '/static/images/auth/' + this.placeholder + '.jpg',
      "alt": "Click to add a picture"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.uploadPhoto($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newImageBase64) ? _c('div', {
    staticClass: "avatar",
    style: ({
      'background-image': 'url(' + _vm.newImageBase64 + ')'
    }),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.uploadPhoto($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-3"
  }, [_c('ul', {
    staticClass: "fs-small bold darker mb-4"
  }, [_c('li', [_vm._v("Minimum dimensions: 300x300px")]), _vm._v(" "), _c('li', {
    class: {
      'color-6': !_vm.isSizeOk
    }
  }, [_vm._v("Max. file size: 1MB")]), _vm._v(" "), _c('li', {
    class: {
      'color-6': !_vm.isFormatOk
    }
  }, [_vm._v("JPG or PNG only")])]), _vm._v(" "), _c('button', {
    staticClass: "btn secondary wide",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.uploadPhoto($event)
      }
    }
  }, [_vm._v("Upload Logo")]), _vm._v(" "), _c('input', {
    ref: "inputAvatarUpload",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.receiveImage
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4530983c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4530983c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AvatarUploader.vue
// module id = 1624
// module chunks = 0